export { default as Specialties } from './Specialties';
